import nascarMK from './assets/Nascar-MKX-Layout-2.jpg';
import nascarAG from './assets/Nascar-Afterglow-Layout-2.jpg';
import jpCycles from './assets/16.02.11-PresDay.jpg';
import magRetail from './assets/16-02-28_ICON.jpg';
import gsTopper from './assets/20.75x14-Topper-StratGuides.jpg';
import gsGondola from './assets/36x10-Gondola-Fall.jpg';
import pdgmVegas from './assets/1080x1080-VegasPDGMNow.gif'
import boocamp from './assets/Bootcamp-Mockup.jpg';
import borderlandEmail from './assets/Borderlands-GameStop.jpg';
import bsnEmail from './assets/bsn-apparel.jpg';
import bsnGenEmail from './assets/bsn-genesis.gif';
import pdgmDallas from './assets/dallas-v2.gif';
import bsnHolidayEmail from './assets/holiday-17.gif';
import gsKit from './assets/LANoire-LaunchKit-Present.jpg';
import gsMicrosoft from './assets/MicrosoftFranchiseFlyer.jpg';
import pdgmNeon from './assets/neon-pdgm-v2.gif';
import razorSmoke from './assets/razor-smoke.gif';
import gsGondolaStep from './assets/StepUpYourGame.jpg';
import shirtPool from './assets/t-shirt-Black-Pool.jpg';
import shirtGS from './assets/t-shirt-Skull.jpg';
import gsPlan from './assets/MB-All.jpg';

//keep at 14 objects

export const DESIGNPORT = [
    {
        projectType:'Nascar Wrap',
        project: 'Mortal Kombat',
        modal: 'nascarMK',
        copy: 'One of a few GameStop Nascar wraps I designed for one of GameStop\'s vendors',
        img: nascarMK,
    },
    {
        projectType:'Social Ad',
        project: 'PDGM Vegas',
        modal: 'vegasPDGM',
        copy: 'Advertising a big seminar to discuss large healthcare policy changes',
        img: pdgmNeon,
    },
    {
        projectType:'In-Store Signage',
        project: 'GameStop Header',
        modal: 'stepUpGS',
        copy: 'In-store signage advertising accessories',
        img: gsGondolaStep,
    },
    {
        projectType:'Email (designed/coded)',
        project: 'BSN Nike/UA Apparel',
        modal: 'nikeUAEmail',
        copy: 'An email advertising new Nike and UnderArmour offered apparel',
        img: bsnEmail,
    },
    {
        projectType:'Launch Kit Box',
        project: 'L.A. Noir Video Game',
        modal: 'laNoir',
        copy: 'A themed box to house all the essentials for handling the launch of a highly anticipated game.',
        img: gsKit,
    },
    {
        projectType:'Email (designed/coded)',
        project: 'Icon Gear',
        modal: 'iconGear',
        copy: 'An email announcing new gear from ICON',
        img: magRetail,
    },
    {
        projectType:'Multi-Page Catalog',
        project: 'GameStop Marketing Plan',
        modal: 'gsMP',
        copy: 'The early plan, prices and statistics sent to all GameStop\'s vendors',
        img: gsPlan,
    },
    {
        projectType:'Email (designed/coded)',
        project: 'J&P Cycles Sale',
        modal: 'jpCycles',
        copy: 'The traditional retail holiday sale email',
        img: jpCycles,
    },
    {
        projectType:'Website Header',
        project: 'Razor Football Pads',
        modal: 'bsnPads',
        copy: 'An eye catching header for a football pads landing page',
        img: razorSmoke,
    },
    {
        projectType:'Social Ad',
        project: 'PDGM Seminar Dallas',
        modal: 'pdgmDallas',
        copy: 'Advertising a big seminar to discuss large healthcare policy changes',
        img: pdgmDallas,
    },
    {
        projectType:'Nascar Wrap',
        project: 'Afterglow Controller',
        modal: 'nascarAG',
        copy: 'One of a few GameStop Nascar wraps I designed for one of GameStop\'s vendors',
        img: nascarAG,
    },
    {
        projectType:'In-Store Signage',
        project: 'Game Guides',
        modal: 'gsGuides',
        copy: 'In-store signage advertising a sale on game guides',
        img: gsTopper,
    },
    {
        projectType:'Email (designed/coded)',
        project: 'BSN Happy Holidays',
        modal: 'bsnHoliday',
        copy: 'The yearly happy holidays email to all vendors',
        img: bsnHolidayEmail,
    },
    {
        projectType:'Social Ad',
        project: 'PDGM Vegas',
        modal: 'pdgmVegas2',
        copy: 'Advertising a big seminar to discuss large healthcare policy changes',
        img: pdgmVegas,
    },
    {
        projectType:'Email (Coded only)',
        project: 'Borderlands',
        modal: 'borderlands',
        copy: 'GameStop email coded into the GameStop template',
        img: borderlandEmail,
    },
    {
        projectType:'T-Shirts',
        project: 'Pool Team',
        modal: 'poolShirts',
        copy: 'Team shirts for a pool league team',
        img: shirtPool,
    },
    {
        projectType:'Sales Flyer',
        project: 'Microsoft',
        modal: 'microsoft',
        copy: 'Brand focused sales flyer',
        img: gsMicrosoft,
    },
    {
        projectType:'T-Shirt',
        project: 'GameStop Mascot',
        modal: 'shirtGS',
        copy: 'GameStop mascot shirts',
        img: shirtGS,
    },
    {
        projectType:'Logo Design',
        project: 'BootCamp',
        modal: 'bootcamp',
        copy: 'A logo created for a bootcamp for a company daily bootcamp',
        img: boocamp,
    },
    {
        projectType:'Email (designed/coded)',
        project: 'Genisis Bow',
        modal: 'genisis',
        copy: 'An email advertising the Genisis Bow',
        img: bsnGenEmail,
    },
    {
        projectType:'In-Store Signage',
        project: 'Fall Gaming',
        modal: 'gsFall',
        copy: 'In-store signage for fall games',
        img: gsGondola,
    }
  ];
  
